<template>
  <div :class="{loading: !productsReady}" style="min-height: 250px">
    <!-- Menu Categories Start -->
    <div v-if="categories.length" class="ct-menu-categories menu-filter">
      <div class="container">
        <Slick :options="categoriesSliderSettings" class="menu-category-slider">
          <div @click="selectedCategory='all'" class="ct-menu-category-item"
               :class="{active: selectedCategory === 'all'}">
            <div class="menu-category-thumb">
              <img :src="getImagePath('assets/images/all_menu_icon.jpg', 'square_68x68')"
                   :alt="$t('All')"
                   width="86px" height="86px">
            </div>
            <div class="menu-category-desc">
              <h6>{{ $t('All') }}</h6>
            </div>
          </div>

          <div v-for="category in categories" :key="category.id" @click="selectedCategory=category.id"
               :class="{active: selectedCategory === category.id}"
               class="ct-menu-category-item">
            <!--             data-filter=".{{ category.id }}"-->
            <div v-if="category.imagePath" class="menu-category-thumb">
              <img :src="getImagePath(category.imagePath, 'square_68x68')"
                   :alt="category.name"
                   width="86px" height="86px">
            </div>
            <div class="menu-category-desc">
              <h6>{{ category.name }}</h6>
            </div>
          </div>
        </Slick>
      </div>
    </div>
    <!-- Menu Categories End -->

    <!-- Menu Wrapper Start -->
    <div v-if="productsReady" class="section section-padding">
      <div class="container">
        <isotope class="menu-container row" :list="products" :options="options">
          <div v-for="product in filteredProducts" :key="product.id"
               class="col-lg-4 col-md-6">
            <div class="product">
              <b-link @click="selectedProduct=product" v-b-modal.product-details-modal v-if="product.imagePath"
                      class="product-thumb" data-toggle="modal">
                <!--                data-target="#productModal_{{ product.id }}"-->
                <img v-lazy="getImagePath(product.imagePath, 'square_250x250')"
                     :alt="product.name"
                     height="250" width="250"
                />
              </b-link>
              <div class="product-body">
                <div class="product-desc">
                  <h4>
                    <b-link @click="selectedProduct=product" v-b-modal.product-details-modal>
                      <!--                          data-target="#productModal_{{ product.id }}"-->
                      {{ product.name }}
                    </b-link>
                  </h4>
                  <p>{{ product.description }}</p>
                  <p v-if="product.productPrices.length > 0" class="product-price">
                        <span v-if="hasMultiplePrices(product)">
                        {{ $t('from') }}
                          </span>
                    <Price :price="product.productPrices[0].gross"/>
                  </p>
                  <!--                  <div class="favorite">-->
                  <!--                    <i class="far fa-heart"></i>-->
                  <!--                  </div>-->
                </div>
                <div class="product-controls">
                  <!--                  <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i-->
                  <!--                      class="fas fa-shopping-cart"></i>-->
                  <!--                  </a>-->
                  <b-button @click="selectedProduct=product" v-b-modal.product-details-modal
                            class="btn-custom secondary btn-sm shadow-none">
                    {{ $t('See more') }}
                    <i class="fas fa-plus"></i>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </isotope>
      </div>
    </div>

    <RestaurantMenuProduct :product="selectedProduct"/>
  </div>
</template>
<script>
import imageMixin from "@/mixins/imageMixin";
import Price from "@/views/partials/Price";
import Slick from 'vue-slick'
import isotope from 'vueisotope'
import RestaurantMenuProduct from "@/views/modules/RestaurantMenuProduct";
import restaurantMenu from "@/data/restaurant-menu.json"
import {BButton, BLink, VBModal} from 'bootstrap-vue'

export default {
  name: 'RestaurantMenu',
  components: {RestaurantMenuProduct, Price, Slick, isotope, BButton, BLink},
  directives: {
    'b-modal': VBModal
  },
  mixins: [imageMixin],
  data() {
    return {
      categories: [],
      products: [],
      productsReady: false,
      selectedCategory: 'all',
      selectedProduct: {},
      isLoading: true,
      options: {
        getSortData: {
          id: "id"
        },
        sortBy: "id"
      },
      categoriesSliderSettings: {
        slidesToShow: 8,
        slidesToScroll: 3,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 6
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2,
            }
          },
        ]
      }
    }
  },
  computed: {
    filteredProducts() {
      var self = this;

      let found = self.products.filter(function (product) {
            // let categoryRegex = new RegExp(self.selectedCategory.replace(/[a-f0-9]{24}/g, ""), 'i');
            // var searchRegex = new RegExp(self.selectedCategory.replace(/[^a-zA-Z0-9 ]/g, ""), 'i');

            let categoryFound = false;
            for (let i = 0; i < product.categories.length; i++) {
              let category = product.categories[i];
              if (category.id === self.selectedCategory) {
                categoryFound = true;
                break;
              }
            }
            return (
                //     categoryRegex.test(product.name) &&
                self.selectedCategory === 'all' || categoryFound
                // searchRegex.test(product.id = self.selectedCategory
            )
          }
      )
      // console.log(found)
      return found;
    }
  },
  beforeMount() {
    // axiosHelper.axios.get(window.apiUrl + '/api/restaurant-menu?groups=default,add-ingredients-to-product,add-prices-to-product,add-categories-to-product,add-size-to-price')
    //     .then(response => {
    let foundCategoryIds = [];
    let categories = [];
    restaurantMenu.forEach(product => {
      product.categories.forEach(category => {
        if (!foundCategoryIds.includes(category.id)) {
          foundCategoryIds.push(category.id);
          if (!category.imagePath && product.imagePath) {
            category.imagePath = product.imagePath;
          }
          categories.push(category);
        }
      });
    })

    if (categories.length < 8) {
      this.categoriesSliderSettings.responsive[0].settings.slidesToShow = categories.length;
    }
    this.categories = categories;
    this.products = restaurantMenu;
    this.productsReady = true;
    //     }
    // );
  },
  methods: {
    hasMultiplePrices(product) {
      return typeof (product.productPrices) != 'undefined'
          && product.productPrices.length > 0
          && typeof (product.productPrices[0].size) != 'undefined';
    }
  }
}
</script>
